module.exports = __webpack_public_path__ + "img/consecuencia6.58223480.png";